import { createContext, useState, useEffect, useRef } from "react";
import { FHIRApi } from "../components/service/fhirAPI";
import { giveEveryData, validateFhirData } from "../fetchData";
import { notification } from "antd";
import { useParamsUrl } from "../hooks/useParamsUrl";

export const ShowContext = createContext();

export const ShowProvider = ({ children }) => {
  const patientDataRef = useRef(null);
  const [api, contextHolder] = notification.useNotification();
  const wholeDataRef = useRef(null);
  const [show, setShow] = useState(false);
  const [patientData, setpatientData] = useState(null);
  const [isPatientFound, setIsPatientFound] = useState(true);
  const [wholeData, setwholeData] = useState(null);
  const [showPatientName, setshowPatientName] = useState(false);
  const [loadingNames, setloadingNames] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [patientId, setPatientId] = useState("");

  const [error, seterror] = useState({
    message: "",
    type: "",
  });
  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        seterror({ message: "", type: "" });
      }, 7000);
    }
    if (!isPatientFound) {
      setTimeout(() => {
        setIsPatientFound(true);
      }, 3000);
    }
  }, [error, isPatientFound]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const openNotification = (issue, message) => {
    api.open({
      message,
      description: (
        <>
          {issue.map((item, idx) => (
            <p key={idx}>{item.details.text}</p>
          ))}
        </>
      ),
      duration: 0,
    });
  };

  async function givePatientData(patientName, removeQueryParams) {
    setloadingNames(true);

    const data = await FHIRApi(patientName, "");

    if (!data.entry) {
      setIsPatientFound(false);
      setpatientData(null);
      setwholeData(null);
      setloadingNames(false);
      return;
    }
    const { issue } = await validateFhirData(data);
    const isValid = issue[0].details.text === "All OK";
    if (isValid) {
      removeQueryParams();
      patientDataRef.current = data;
      setpatientData(data);
      setloadingNames(false);
    } else {
      openNotification(issue, "Validation error");
      setloadingNames(false);
    }
  }

  async function giveWholeData(patientId) {
    setloading(true);
    const getWholeData = await giveEveryData(patientId);
    if (getWholeData.data === false) {
      setloading(false);
      openNotification(getWholeData.issue, "Validation Error");
      return;
    }
    wholeDataRef.current = getWholeData;
    setwholeData(getWholeData);
    setloading(false);
  }

  useEffect(() => {
    if (patientDataRef.current) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  const values = {
    show,
    setShow,
    givePatientData,
    patientDataRef,
    patientData,
    wholeData,
    wholeDataRef,
    isPatientFound,
    setIsPatientFound,
    showPatientName,
    setshowPatientName,
    seterror,
    error,
    loading,
    giveWholeData,
    loadingNames,
    contextHolder,
    isModalOpen,
    setIsModalOpen,
    showModal,
    patientId,
    setPatientId,
    setpatientData,
  };

  return <ShowContext.Provider value={values}>{children}</ShowContext.Provider>;
};
